export default __webpack_public_path__ + "static/media/photo1.5e669c1a.jpg";